export const MODAL_TYPES = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  GAME_SUCCESS: 'GAME_SUCCESS',
  GAME_FAILURE: 'GAME_FAILURE',
  EARLY_EXIT: 'EARLY_EXIT',
  NOTIFICATION: 'NOTIFICATION',
  NEW_QUESTS_AVAILABLE: 'NEW_QUESTS_AVAILABLE',
  END_OF_QUESTS: 'END_OF_QUESTS',
  CHALLENGE_QUEST: 'CHALLENGE_QUEST',
  CHALLENGE_QUEST_SUCCESS: 'CHALLENGE_QUEST_SUCCESS',
  END_OF_ALL_QUESTS_AND_CHALLENGES: 'END_OF_ALL_QUESTS_AND_CHALLENGES',
  GAME_SELECTOR: 'GAME_SELECTOR',
  FLUENCY_LAUNCH: 'FLUENCY_LAUNCH',
  VOCAB_LAUNCH: 'VOCAB_LAUNCH',
  VOCAB_SUCCESS: 'VOCAB_SUCCESS',
  VOCAB_EARLY_EXIT: 'VOCAB_EARLY_EXIT',
  TFE_LAUNCH: 'TFE_LAUNCH',
  TFE_SUCCESS: 'TFE_SUCCESS',
  TFE_EARLY_EXIT: 'TFE_EARLY_EXIT',
  EREADER_LAUNCH: 'EREADER_LAUNCH',
  EREADER_SUCCESS: 'EREADER_SUCCESS',
  EREADER_EARLY_EXIT: 'EREADER_EARLY_EXIT',
  RE_PLACEMENT: 'RE_PLACEMENT',
  LEVEL_SUMMARY: 'LEVEL_SUMMARY',
  QUEST_COMPLETE: 'QUEST_COMPLETE',
  SESSION_TIMEOUT: 'SESSION_TIMEOUT',
  GLOBAL_NAV_LOGOUT: 'GLOBAL_NAV_LOGOUT',
  MULTIPLE_SESSIONS: 'MULTIPLE_SESSIONS',
};

export const MODAL_PRIORITY_MAP = {
  [MODAL_TYPES.GLOBAL_NAV_LOGOUT]: 9,
  [MODAL_TYPES.RE_PLACEMENT]: 8,
  [MODAL_TYPES.TFE_EARLY_EXIT]: 7,
  [MODAL_TYPES.TFE_SUCCESS]: 7,
  [MODAL_TYPES.EREADER_EARLY_EXIT]: 7,
  [MODAL_TYPES.EREADER_SUCCESS]: 7,
  [MODAL_TYPES.VOCAB_EARLY_EXIT]: 7,
  [MODAL_TYPES.VOCAB_SUCCESS]: 7,
  [MODAL_TYPES.LOGOUT]: 9,
  [MODAL_TYPES.LOGIN]: 7,
  [MODAL_TYPES.MULTIPLE_SESSIONS]: 8,
  [MODAL_TYPES.NOTIFICATION]: 5,
  [MODAL_TYPES.LEVEL_SUMMARY]: 5,
  [MODAL_TYPES.QUEST_COMPLETE]: 5,
  [MODAL_TYPES.GAME_SUCCESS]: 4,
  [MODAL_TYPES.CHALLENGE_QUEST]: 4,
  [MODAL_TYPES.CHALLENGE_QUEST_SUCCESS]: 3,
  [MODAL_TYPES.END_OF_ALL_QUESTS_AND_CHALLENGES]: 2,
  [MODAL_TYPES.END_OF_QUESTS]: 1,
};
